import script from "./CookieConsentBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./CookieConsentBanner.vue?vue&type=script&setup=true&lang=ts"

import "./CookieConsentBanner.vue?vue&type=style&index=0&id=21ba8b8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21ba8b8c"]])

export default __exports__